import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import MessageReactionsList from './MessageReactionsList';
const ReactionsWrapper = styled.div `
  display: flex;
  padding-top: 2px;
  padding-left: 2.5rem;
  width: fit-content;
  padding-bottom: 4px;
  column-gap: 0.25rem;
  font-size: 1rem;
  line-height: 1rem;
  cursor: pointer;
`;
const parseReactions = (reactions) => {
    if (!reactions || Object.keys(reactions).length === 0) {
        return [];
    }
    return Object.entries(reactions).map(([reaction, accountsForReaction]) => {
        return {
            reaction,
            accounts: accountsForReaction !== null && accountsForReaction !== void 0 ? accountsForReaction : [],
        };
    });
};
const ReactionEmojiWrapper = styled.div `
  height: 24px;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  ${(props) => props.$isOwnReaction
    ? 'background-color: #372D19;'
    : 'background-color: #1e1f28;'}
  &:hover {
    ${(props) => props.$isOwnReaction
    ? 'background-color: #4D3F24;'
    : 'background-color: #2A2B37;'}
  }
  border-radius: 4px;
`;
const ReactionEmojiComponentButtonContainer = styled.div `
  position: relative;
`;
const ReactionAccountsContainer = styled.div `
  color: #fff;
  display: flex;
  align-items: center;
  height: 80px;
  width: 281px;
  column-gap: 8px;
  font-size: 1.5rem;
  line-height: 1.75rem;
  background-color: #1d1d21;
  border-radius: 4px;
  padding: 8px;
`;
const HoverContainer = styled.div `
  position: absolute;
  bottom: 1rem;
  left: 0rem;
  z-index: 40;
  padding: 16px 16px 16px 0px;
  @media (max-width: 1024px) {
    display: none;
  }
`;
const ReactedByReaction = styled.div `
  width: 32px;
  height: 32px;
`;
const ReactedByContainer = styled.div `
  font-family: Helvetica Neue;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  -webkit-font-smoothing: antialiased applied;
`;
const ReactionCountWrapper = styled.div `
  font-size: 12px;
  line-height: 100%;
  color: #fff;
  -webkit-font-smoothing: antialiased applied;
`;
const OthersButton = styled.span `
  color: #4e95ff;
  text-decoration: underline;
  &:hover {
    color: #73aaff;
  }
`;
const Text = styled.div ``;
const ReactionDescription = ({ accounts, openMessageReactionsList, }) => {
    const accountsCount = accounts.length;
    if (accountsCount <= 3) {
        return _jsx(Text, { children: `reacted by ${accounts.join(', ')}` });
    }
    else {
        const initialAccounts = accounts.slice(0, 3).join(', ');
        const othersCount = accountsCount - 3;
        return (_jsxs(Text, { children: [`reacted by ${initialAccounts} and `, _jsx(OthersButton, Object.assign({ onClick: openMessageReactionsList }, { children: `${othersCount} other${othersCount > 1 ? 's' : ''}` }))] }));
    }
};
const ReactionEmojiComponentButton = ({ accountId, reaction, handleReaction, openMessageReactionsList, }) => {
    const [showWhoReacted, setShowWhoReacted] = useState(false);
    return (_jsxs(ReactionEmojiComponentButtonContainer, Object.assign({ onMouseEnter: () => setShowWhoReacted(true), onMouseLeave: () => setShowWhoReacted(false) }, { children: [_jsxs(ReactionEmojiWrapper, Object.assign({ "$isOwnReaction": reaction.accounts.includes(accountId), onClick: () => handleReaction(reaction.reaction) }, { children: [reaction.reaction, _jsx(ReactionCountWrapper, { children: reaction.accounts.length.toString() })] })), showWhoReacted && (_jsx(HoverContainer, { children: _jsxs(ReactionAccountsContainer, { children: [_jsx(ReactedByReaction, { children: reaction.reaction }), _jsx(ReactedByContainer, { children: _jsx(ReactionDescription, { accounts: reaction.accounts, openMessageReactionsList: () => openMessageReactionsList(reaction) }) })] }) }))] })));
};
const MessageReactionsField = ({ reactions, accountId, handleReaction, getIconFromCache, isMessageRectionListVisible, openMessageReactionsList, closeMessageReactionsList, selectedReaction, }) => {
    const parsedReactions = parseReactions(reactions);
    return (_jsxs(_Fragment, { children: [_jsx(ReactionsWrapper, { children: parsedReactions.map((parsedReaction, id) => (_jsx("div", { children: parsedReaction.accounts.length > 0 && (_jsx(ReactionEmojiComponentButton, { accountId: accountId, reaction: parsedReaction, handleReaction: handleReaction, openMessageReactionsList: openMessageReactionsList }, id)) }, id))) }), isMessageRectionListVisible && (_jsx(MessageReactionsList, { reactions: parsedReactions, selectedReaction: selectedReaction !== null && selectedReaction !== void 0 ? selectedReaction : parsedReactions[0], getIconFromCache: getIconFromCache, closeMessageReactionsList: closeMessageReactionsList }))] }));
};
export default MessageReactionsField;
